import {Injectable} from '@angular/core';

export interface IAbout {
  img: string;
  header: string;
  description: string;
  num: string;
}

@Injectable({
  providedIn: 'root'
})
export class AboutUsService {

  data = [
    {
      img: 'assets/img/about-icon.png',
      header: 'Наукова точність',
      description: 'Anima поєднує в собі технологію ай-трекінгу з добре відомими психометричними тестами та аналізує біомаркери уваги. Така комбінація технологій і науки дозволяє більш точно оцінити різні психічні стани: тривогу, депресію та рівень стресу, навіть у ситуаціях, де самооцінка може бути ненадійною.',
      num: '01'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Персоналізовані інсайти',
      description: 'Унікальний підхід Anima не просто визначає потенційні проблеми психічного стану, а й пропонує персоналізований аналіз та рекомендації. Anima пропонує індивідуальні стратегії для покращення психічного добробуту, оскільки розуміє ваші особисті налаштування системи уваги.',
      num: '02'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Конфіденційність і безпека',
      description: 'Anima з особливою турботою дбає про конфіденційність, тому використовує камеру лише для визначення маркерів погляду і записує лише його координати. Відео чи зображення не записуються та не зберігаються.',
      num: '03'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Доступність і зручність',
      description: 'Anima як онлайн-сервіс легко доступна для всіх, хто прагне зрозуміти та покращити свій психічний стан. Наша зручна вебплатформа робить моніторинг психічного стану неодмінною частиною щоденної турботи про ментальний добробут.',
      num: '04'
    }
  ];

  constructor() {
  }

  getList() {
    return this.data;
  }

  private createItem(prop: IAbout): IAbout {
    return {
      img: prop.img,
      header: prop.header,
      description: prop.description,
      num: prop.num
    };
  }
}
